import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import infoIcon from "../../assets/images/infobtnblue.svg";
import { apiResponse } from "../../services/APIResponse";
import { API_URL } from "../../services/APIRoute";
import { commonservices } from "../../services/CommonServices";
import { apiCall } from "../../services/AxiosService";
import {
  UpdateMachine,
  UpdateReviewComment,
} from "../../services/ReduxTookit/Slice/MachineRedux";
import { useDispatch, useSelector } from "react-redux";
import SubmitLoading from "../common-component/Loaders/SubmitLoading";
import CKeditorComponent from "../common-component/CKeditorComponent";
import MainpageLoader from "../common-component/Loaders/MainpageLoader";
import { rejectFAQState } from "../../services/ReduxTookit/UserInfoSlice";

const FAQEditMarketplaceModal = (props) => {
  let dispatch = useDispatch();
  const FAQListData = useSelector((state) => state?.userinfo?.RejectFAQData);

  const countFalseValues = () => {
    return Object.values(props?.geteditstatus).filter(
      (value) => value === false
    ).length;
  };
  const [Loading, setLoading] = useState(false);
  const [input, setinput] = useState({
    machineid: "",
    price: "",
    subcategoryid: "",
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    compatiblemachineids: "",
    dependentmachineids: "",
    cloud: "",
  });
  const [Newmachinefaq, setNewmachinefaq] = useState({
    question: "",
    answer: "",
    faqid: "",
    errors: {
      question: "",
      answer: "",
      ValidationRules: [
        {
          FieldName: "question",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "answer",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  useEffect(() => {
    if (props?.machinedata) {
      setinput({
        ...input,
        price: props?.machinedata?.dataList1?.[0]?.price
          ? props?.machinedata?.dataList1?.[0]?.price
          : 0,
        subcategoryid: props?.machinedata?.dataList1?.[0]?.subcategoryid
          ? props?.machinedata?.dataList1?.[0]?.subcategoryid
          : 0,
        osrequirmet: props?.machinedata?.dataList2?.[0]?.osrequirmet,
        storage: props?.machinedata?.dataList2?.[0]?.storage,
        ram: props?.machinedata?.dataList2?.[0]?.ram,
        cpu: props?.machinedata?.dataList2?.[0]?.cpu,
        compatiblemachineids:
          props?.machinedata?.dataList2?.[0]?.compatiblemachineids,
        dependentmachineids:
          props?.machinedata?.dataList2?.[0]?.dependentmachineids,
        cloud: props?.machinedata?.dataList2?.[0]?.cloud,
      });
    }
  }, [props?.machinedata]);
  useEffect(() => {
    if (props?.type === "Edit") {
      setNewmachinefaq({
        ...Newmachinefaq,
        question: props?.selecteddata?.question || "",
        answer: props?.selecteddata?.answer || "",
        faqid: props?.selecteddata?.faqid || "",
      });
    }
  }, [props?.selecteddata]);

  const UpdateMachineData = (e) => {
    e.preventDefault();
    let NewData = props?.allfaqdata;
    let obj = commonservices.fnCheckValidationOfObject(Newmachinefaq);
    setNewmachinefaq({
      ...obj.obj,
    });
    if (obj.isValid) {
      const updatedData = NewData.map((item) => {
        if (item.faqid === Newmachinefaq.faqid) {
          return {
            ...item,
            question: Newmachinefaq?.question,
            answer: Newmachinefaq?.answer,
          };
        }
        return item;
      });

      props.setfaqdata(updatedData);
      let a = FAQListData?.filter((item) => item.faqid !== Newmachinefaq.faqid);

      dispatch(rejectFAQState(a));

      // if (a?.length > 0) {
      // props.setParamArray(a)
      props.onHide();
      // } else {
      //   updateReviewStatus(e);
      // }
    }
  };

  const updateReviewStatus = async (e) => {
    e.preventDefault();
    let obj = commonservices.fnCheckValidationOfObject(Newmachinefaq);
    setNewmachinefaq({
      ...obj.obj,
    });
    if (obj.isValid) {
      setLoading(true);
      let newbody = {
        machineid: props?.versionlist?.machineid,
        versionnumber: props?.versionlist?.number,
        booleanfield: props?.updatereviewcommentdata?.booleanfield,
        commentfield: props?.updatereviewcommentdata?.commentfield,
        commentfieldvalue: props?.updatereviewcommentdata?.commentfieldvalue,
      };

      dispatch(UpdateReviewComment(newbody))?.then((response) => {
        if (response?.payload?.isValidate) {
          handleSubmit();
        }
        if (!response?.payload?.isValidate) {
        }
      });
    }
  };

  

  const handleSubmit = async () => {
    let formData = new FormData();
    let prevdata = [];
    props?.allfaqdata?.forEach((element) => {
      if (props?.type === "Edit") {
        if (element?.faqid === props?.selecteddata?.faqid) {
          const updatedElement = {
            ...element,
            question: Newmachinefaq?.question,
            answer: Newmachinefaq?.answer,
          };
          prevdata.push({
            question: updatedElement?.question,
            answer: updatedElement?.answer,
          });
        } else {
          prevdata.push({
            question: element?.question,
            answer: element?.answer,
          });
        }
      } else {
        prevdata.push({
          question: element?.question,
          answer: element?.answer,
        });
      }
    });
    if (props?.type !== "Edit") {
      prevdata.push({
        question: Newmachinefaq?.question,
        answer: Newmachinefaq?.answer,
      });
    }
    let tempobj = [...prevdata];
    let body = {
      machineid: props?.versionlist?.machineid,
      price: input?.price ? input?.price : 0,
      subcategoryid: input?.subcategoryid ? input?.subcategoryid : 0,
      osrequirmet: input?.osrequirmet,
      storage: input?.storage,
      ram: input?.ram,
      cpu: input?.cpu,
      compatiblemachineids: input?.compatiblemachineids
        ? input?.compatiblemachineids
        : "",
      dependentmachineids: input?.dependentmachineids
        ? input?.dependentmachineids
        : "",
      cloud: input?.cloud,
      machinefaqs: tempobj,
    };
    for (const [key, value] of Object.entries(body)) {
      if (
        typeof value === "object" &&
        Array.isArray(value) &&
        key !== "componentjson"
      ) {
        value?.map((item, index) => {
          for (const [nestedKey, nestedValue] of Object.entries(item)) {
            formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
          }
        });
      } else {
        formData.append(`${key}`, value);
      }
    }
    if (countFalseValues() === 1) {
      body = { ...body, status: "In Process" };
    } else {
      body = { ...body, status: "Rejected" };
    }
    dispatch(UpdateMachine(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        props.onHide();
        props.bindlist(props?.versionlist?.machineid);
        props.bindlist1();
        if (countFalseValues() === 1) {
          props.setversionstate({
            ...props?.versionlist,
            status: "In Process",
          });
        } else {
          props.setversionstate({
            ...props?.versionlist,
            status: "Rejected",
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };

  const handleCKEditor = (content, tag) => {
    setNewmachinefaq({
      ...Newmachinefaq,
      [tag]: content,
      errors: {
        ...Newmachinefaq.errors,
        [tag]: "",
      },
    });
  };
  const fnInputChange = (value, tag) => {
    if (value) {
      setNewmachinefaq({
        ...Newmachinefaq,
        [tag]: value,
        errors: {
          ...Newmachinefaq.errors,
          [tag]: "",
        },
      });
    } else {
      setNewmachinefaq({
        ...Newmachinefaq,
        [tag]: "",
      });
    }
  };
  useEffect(() => {
    const cleanup = commonservices.setupKeyPressHandler(handleSubmit);
    return cleanup;
  }, [handleSubmit]);

  // Add or remove 'loadtime' class based on MachineLoader

 useEffect(() => {
  if (Loading) {
    document.body.classList.add('loadtime');
  } 
  // else {
  //   document.body.classList.remove('loadtime');
  // }

  // Cleanup when component unmounts
  return () => {
    document.body.classList.remove('loadtime');
  };
}, [Loading]); // Re-run this effect when MachineLoader changes

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      {Loading && <MainpageLoader />}
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props?.type} Frequently Asked Questions (FAQs)
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          // if (props?.type === "Edit") {
          //   if (FAQListData?.length > 0) {
          UpdateMachineData(e);
          //   } else {
          //     updateReviewStatus(e);
          //   }
          // } else if (props?.type === "Add") {
          //   updateReviewStatus(e);
          // }
        }}
      >
        <Modal.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Question<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type="text"
                    className="common-input"
                    value={Newmachinefaq?.question}
                    // onChange={(e) => {
                    //   setNewmachinefaq({
                    //     ...Newmachinefaq,
                    //     question: e.target.value,

                    //   });
                    // }}
                    onChange={(e) => fnInputChange(e.target.value, "question")}
                    isInvalid={Newmachinefaq?.errors?.question}
                  />
                  {Newmachinefaq?.errors?.question && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachinefaq?.errors?.question}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div>
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="form-group mb16">
                <Form.Label className="common-label">
                  Answer<span className="ms-1 red-color-text">*</span>
                </Form.Label>
                {/* <div className="position-relative">
                  <Form.Control
                    as="textarea"
                    className="common-input"
                    style={{ minHeight: "100px" }}
                    value={Newmachinefaq?.answer}
                    onChange={(e) => {
                      setNewmachinefaq({
                        ...Newmachinefaq,
                        answer: e.target.value,
                      });
                    }}
                    isInvalid={Newmachinefaq?.errors?.answer}
                  />
                  {Newmachinefaq?.errors?.answer && (
                    <Form.Control.Feedback type="invalid">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachinefaq?.errors?.answer}
                        />
                      </span>
                    </Form.Control.Feedback>
                  )}
                </div> */}
                <div className="position-relative">
                  <div
                    className={`${
                      Newmachinefaq?.errors?.answer && "error-border-line"
                    }`}
                  >
                    <CKeditorComponent
                      onChange={handleCKEditor}
                      tag="answer"
                      value={Newmachinefaq?.answer}
                    />
                  </div>
                  {Newmachinefaq?.errors?.answer && (
                    <p className="error-line">
                      <span className="error-message-icon">
                        <img
                          src={infoIcon}
                          alt="infoIcon"
                          title={Newmachinefaq?.errors?.answer}
                        />
                      </span>
                    </p>
                  )}
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <button className="grey-btn w-auto" onClick={props.onHide}>
            Cancel
          </button>
          <button disabled={Loading} className="blue-btn w-auto" type="submit">
            {Loading ? <SubmitLoading /> : "Submit"}
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default FAQEditMarketplaceModal;
